<div class="row">
    <div class="col-12">

        <div class="card">
            <div class="card-header">
                <div class="title">{{ 'SUBSC.SUBSC_LIST.SUBS_LIST' | translate }}</div>
                <div class="tools">
                    <button type="button" class="btn btn-primary btn-sm" (click)="onCreate()">
                        <i class="bi bi-plus-circle"></i> {{ 'ADD' | translate }}
                    </button>
                </div>
            </div>

            <div class="card-body">

                <table class="table table-hover">
                    <thead>
                        <tr>
                            <th scope="col" class="checkbox">
                                <div class="custom-control custom-checkbox">
                                    <input class="custom-control-input" type="checkbox" name="select_subcription_all"
                                        id="select_subcription_all" [checked]="isAllCheckBoxChecked()"
                                        [indeterminate]="checkedButNotAllCheckBox()"
                                        (change)="checkAllCheckBox($event)">
                                    <label class="custom-control-label" for="select_subcription_all"></label>
                                </div>
                            </th>
                            <th scope="col" class="name">{{ 'SUBSC.SUBS_NAME' | translate }}</th>
                            <th scope="col" class="name">{{ 'DESCRIPTION' | translate }}</th>
                            <th scope="col" class="type">{{ 'TYPE' | translate }}</th>
                            <th scope="col" class="status">{{ 'STATUS' | translate }}</th>
                            <th scope="col" class="action">{{ 'ACTION' | translate }}</th>
                        </tr>
                    </thead>

                    <tbody *ngIf="subscriptionsList && subscriptionsList.length > 0">
                        <tr *ngFor="let subcription of subscriptionsList; let i = index">
                            <td class="checkbox">
                                <div class="custom-control custom-checkbox">
                                    <input class="custom-control-input" type="checkbox" name="select_subcription_{{ i }}"
                                        id="select_subcription_{{ i }}" [checked]="subcription.checked"
                                        (change)="selectedCheckBox(i, $event)">
                                    <label class="custom-control-label" for="select_subcription_{{ i }}"></label>
                                </div>
                            </td>
                            <td class="name">{{subcription.name}}</td>
                            <td class="name">{{subcription.desc}}</td>
                            <td class="type">{{ subcription.type.name }}</td>
                            <td class="status">{{ subcription.state.name }}</td>
                            <td class="action">
                                <button type="button" class="btn btn-light" routerLink="/subcription/edit/{{ subcription.id }}"
                                    placement="top" ngbTooltip="{{ 'EDIT' | translate }}">
                                    <i class="bi bi-pencil-square"></i>
                                </button>
                                <button type="button" class="btn btn-light" (click)="onConfirm([subcription.id])"
                                    placement="top" ngbTooltip="{{ 'DELETE' | translate }}">
                                    <i class="bi bi bi-trash"></i>
                                </button>
                            </td>
                        </tr>
                    </tbody>

                    <tbody *ngIf="!subscriptionsList || subscriptionsList.length == 0">
                        <tr>
                            <td *ngIf="loading" class="data-loading" colspan="5">
                                <div class="spinner-bars">
                                    <div class="loadingio-spinner-bars-preLoder-inner">
                                        <div class="preLoder">
                                            <div></div><div></div><div></div><div></div>
                                        </div>
                                    </div>
                                    <div>{{ 'LOADING' | translate }}</div>
                                </div>
                            </td>
                            <td *ngIf="!loading" class="data-not-found" colspan="5">
                                <div>{{ 'DATA_NOT_FOUND' | translate }}</div>
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
            <div class="card-footer">
                <app-pagination [pageData]="paginationInput" (pageEvent)="pageEvent($event)"></app-pagination>
            </div>
        </div>
    </div>
</div>